if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.dataset.wolfUnified !== 'true') this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.dataset.wolfUnified === 'true') {
          const purchasing = this.closest('[data-wolf-product-id]')?.querySelector('wolf-purchasing');
          if (purchasing?.submit) purchasing.submit(this);
          else this.handleErrorMessage('Availability could not be checked. Please reload the page.');
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const run = window.WolfCartMutation?.run || ((task) => task());
        return run(() => fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              const message = typeof response.description === 'string'
                ? response.description
                : 'Availability changed. Please review the quantities in your bag.';
              try {
                if (!await this.refreshCartAfterError(formData.get('id'), message)) this.handleErrorMessage(message);
              } catch (_) {
                this.handleErrorMessage('We could not refresh your bag. Items may have been added. Open your bag to check before adding again.');
              }
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            this.cart.classList.remove('is-empty');
            this.renderCart(response);
          })
          .catch(async () => {
            const message = 'Your bag has been refreshed. Please check the quantities before adding this item again.';
            try {
              if (await this.refreshCartAfterError(formData.get('id'), message)) return;
            } catch (_) { /* A lost response may still have added items; never repeat the POST. */ }
            this.handleErrorMessage('We could not confirm the change. Open your bag to check before adding this item again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }));
      }

      renderCart(response, notice = '') {
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => this.cart.renderContents(response, notice));
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response, notice);
        }
      }

      async refreshCartAfterError(variantId, notice) {
        if (typeof this.cart?.showNotice !== 'function') return false;
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        const url = new URL(routes.cart_url, window.location.origin);
        url.searchParams.set('sections', sections.join(','));
        const [cartResponse, sectionsResponse] = await Promise.all([
          fetch(`${routes.cart_url}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } }),
          fetch(url.toString(), { cache: 'no-store' }),
        ]);
        if (!cartResponse.ok || !sectionsResponse.ok) throw new Error('Unable to refresh bag');
        const [cart, rendered] = await Promise.all([cartResponse.json(), sectionsResponse.json()]);
        if (!Array.isArray(cart.items) || sections.some((id) => !rendered[id])) throw new Error('Unable to refresh bag');
        this.cart.classList.toggle('is-empty', cart.item_count === 0);
        // Notify before replacing the drawer, so its old items cannot overwrite the new notice.
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: cart });
        this.renderCart({ ...cart, id: variantId, sections: rendered }, notice);
        return true;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
